export const TEST_CATEGORY_CREATE_REQUEST = 'TEST_CATEGORY_CREATE_REQUEST'
export const TEST_CATEGORY_CREATE_SUCCESS = 'TEST_CATEGORY_CREATE_SUCCESS'
export const TEST_CATEGORY_CREATE_FAIL = 'TEST_CATEGORY_CREATE_FAIL'
export const TEST_CATEGORY__CREATE_RESET = 'TEST_CATEGORY__CREATE_RESET'


export const LIST_CAT_REQUEST = 'LIST_CAT_REQUEST'
export const LIST_CAT_SUCCESS = 'LIST_CAT_SUCCESS'
export const LIST_CAT_FAIL = 'LIST_CAT_FAIL'
export const LIST_CAT_RESET = 'LIST_CAT_RESET'


export const TEST_CAT_DELETE_REQUEST = 'TEST_CAT_DELETE_REQUEST'
export const TEST_CAT_DELETE_SUCCESS = 'TEST_CAT_DELETE_SUCCESS'
export const TEST_CAT_DELETE_FAIL = 'TEST_CAT_DELETE_FAIL'


export const TEST_UPDATE_CAT_REQUEST = 'TEST_UPDATE_CAT_REQUEST'
export const TEST_UPDATE_CAT_SUCCESS = 'TEST_UPDATE_CAT_SUCCESS'
export const TEST_UPDATE_CAT_FAIL = 'TEST_UPDATE_CAT_FAIL'
export const TEST_UPDATE_CAT_RESET = 'TEST_UPDATE_CAT_RESET'


export const TEST_CAT_DETAILS_REQUEST = 'TEST_CAT_DETAILS_REQUEST'
export const TEST_CAT_DETAILS_SUCCESS = 'TEST_CAT_DETAILS_SUCCESS'
export const TEST_CAT_DETAILS_FAIL = 'TEST_CAT_DETAILS_FAIL'


export const LIST_TEST_REQUEST = 'LIST_TEST_REQUEST'
export const LIST_TEST_SUCCESS = 'LIST_TEST_SUCCESS'
export const LIST_TEST_FAIL = 'LIST_TEST_FAIL'
export const LIST_TEST_RESET = 'LIST_TEST_RESET'


export const TEST_DELETE_REQUEST = 'TEST_DELETE_REQUEST'
export const TEST_DELETE_SUCCESS = 'TEST_DELETE_SUCCESS'
export const TEST_DELETE_FAIL = 'TEST_DELETE_FAIL'


export const TEST_UPDATE_REQUEST = 'TEST_UPDATE_REQUEST'
export const TEST_UPDATE_SUCCESS = 'TEST_UPDATE_SUCCESS'
export const TEST_UPDATE_FAIL = 'TEST_UPDATE_FAIL'
export const TEST_UPDATE_RESET = 'TEST_UPDATE_RESET'


export const TEST_CREATE_REQUEST = 'TEST_CREATE_REQUEST'
export const TEST_CREATE_SUCCESS = 'TEST_CREATE_SUCCESS'
export const TEST_CREATE_FAIL = 'TEST_CREATE_FAIL'
export const TEST_CREATE_RESET = 'TEST_CREATE_RESET'

export const TEST_DETAILS_REQUEST = 'TEST_DETAILS_REQUEST'
export const TEST_DETAILS_SUCCESS = 'TEST_DETAILS_SUCCESS'
export const TEST_DETAILS_FAIL = 'TEST_DETAILS_FAIL'

export const TEST_USER_DETAILS_REQUEST = 'TEST_USER_DETAILS_REQUEST'
export const TEST_USER_DETAILS_SUCCESS = 'TEST_USER_DETAILS_SUCCESS'
export const TEST_USER_DETAILS_FAIL = 'TEST_USER_DETAILS_FAIL'

export const LIST_PAID_ENUMS_REQUEST = 'LIST_PAID_ENUMS_REQUEST'
export const LIST_PAID_ENUMS_SUCCESS = 'LIST_PAID_ENUMS_SUCCESS'
export const LIST_PAID_ENUMS_FAIL = 'LIST_PAID_ENUMS_FAIL'
export const LIST_PAID_ENUMS_RESET = 'LIST_PAID_ENUMS_RESET'